import Image from "next/image";

const LOGOS = [
  'amazon-logo.svg',
  'snowflake-logo.svg',
  'bytedance-logo.svg',
  'paytm-logo.svg',
  'salesforce.svg',
];

export function TrustBuilderLogos({ className }: { className?: string }) {
  const height = 20;
  
  return (
    <div className={`${className || ''}`}>
      <p className={'mb-4 md:mb-2 text-center text-gray-700 dark:text-gray-300'}>Trusted by over {"40,000"} every month</p>
      <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
        {LOGOS.map(src => (
          <Image 
            key={src} 
            className="my-0 grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300 dark:invert dark:opacity-60 dark:hover:opacity-90 dark:grayscale dark:hover:grayscale" 
            src={`/logos/${src}`} 
            width={113.75}
            height={70}
            alt=""
          />
        ))}
      </div>
    </div>
  );
} 